/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Event from './Event/index'
import React from 'react'
import VirtualizedList from 'DesignSystem/VirtualizedList/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content"
  
}) {
  let isMedia = useIsMedia()
let messageComposePinToBottomValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'pinToBottom',
})
let eventsValueData = fromData.useDataValue({ viewPath,
context: 'events',
})
  return (<React.Fragment
>
<VirtualizedList
  viewPath={`${viewPath}/VirtualizedList`}
 data="message_compose.pinToBottom"
 pinToBottom={messageComposePinToBottomValueData}
 data="events"
 from={eventsValueData}
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 paddingLeft={isMedia.mobile ? "0px" : "8px"}
 paddingRight={isMedia.mobile ? "0px" : "8px"}
 paddingBottom={8}
 overscan={50}
 sizeEstimate={70}
 childName="Event"
>
{childProps => (
<Event
{...childProps}
  viewPath={`${viewPath}/Event`}
/>
)}
</VirtualizedList>
{children}
</React.Fragment>)
}